import { doc } from 'firebase/firestore';
import type { OtaConfig } from '@h2h/shared';
import { db } from '../../lib/firebase';
import { useLiveDoc } from '../firestore/live';

/**
 * The OTA live-update manifest (`config/ota`) — the single live web-bundle
 * pointer + kill switch. World-readable, so the native updater can read it before
 * sign-in. Live, so flipping the kill switch or publishing a release from the
 * admin dashboard reaches even already-open apps within seconds.
 */
export function useOtaConfig() {
  return useLiveDoc<OtaConfig>(['otaConfig'], doc(db, 'config', 'ota'), true);
}
